var t="aptos:devnet",o="aptos:testnet",A="aptos:localnet",T="aptos:mainnet",e=[t,o,A,T];export{t as a,o as b,A as c,T as d,e};
//# sourceMappingURL=chunk-3XZSACFC.mjs.map